import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {

};

const getters = {

};

const actions = {
    async sendDispute(context, data) {
        return await axios.post(`${backendUrl()}/updateDocumentDisputeStatus`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            return response.data
        })
    },
    
    async getDisputeStatuses(context, data) {
        return await axios.post(`${backendUrl()}/getDisputeStatuses`, null,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },

    async getDisputeReasons(context, data) {
        return await axios.post(`${backendUrl()}/getDisputeReasons`, null,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },

    async getDisputesList(context, data) {
        return await axios.get(`${backendUrl()}/getDisputesList`, {
            params: { 
                currentPage: data.currentPage, 
                perPage: data.perPage,
                userLevel: data.userLevel,
                date_from : data.date_from,
                date_to : data.date_to,
                doc_reference : data.doc_reference,
                cust_reference: data.cust_reference,
                reason: data.reason
            },       
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },
};

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}